
    import "/home/git/waysglob/website/src/pages/index/svg/index.module.scss.FARM_CSS_MODULES?bd5e9dba";
    
    export default {"rotate": `rotate-36a15658`,"svgComp": `svgComp-36a15658`}
    